'use client';

import FooterFeedbackWidget from './FooterFeedback/FooterFeedbackWidget';

/** Client boundary wrapper so the async footer server component can render feedback safely. */
const FooterFeedbackSection = () => {
  return <FooterFeedbackWidget />;
};

export default FooterFeedbackSection;
